module.exports = __webpack_public_path__ + "img/1.0cecc466.png";